import { SlButton, SlDrawer } from "@shoelace-style/shoelace/shoelace";
import { notNull } from "../../../../../vendor/plugins/clxMobileNetPortable/assets/responsive/js/common/assert";
import { ReloadManager } from "../reloadManager";

export class Articlelist {
    private readonly viewRoot: HTMLElement;
    private readonly reloadManager: ReloadManager;

    constructor(viewRoot: HTMLElement) {
        this.viewRoot = viewRoot;
        this.reloadManager = new ReloadManager();
    }
    public init() {
        this.registerEventListeners();
    }

    private registerEventListeners(): void {
        this.addShowCategoriesListeners();
        this.addBrandListeners();
        this.addHideCategoriesListeners();
        this.clickCategoriesListener();
        this.resetFilterListeners();
        this.resetFilterListenersByOneItem();
        this.submitListenersByOrderByFilter();
        this.moreFilterListener();
        this.changeColorSizeClickListener();
        this.changeTarifdetailColorSizeClickListener();
        this.showMoreArticlesListener();
    }
    /**
     *  in der artikelliste gibt was "alle" Hersteller button
     */
    private addBrandListeners(): void {
        const allBrands = this.viewRoot.querySelector(
            "#all_hersteller",
        ) as HTMLInputElement;
        if (allBrands) {
            allBrands.addEventListener("click", (event: MouseEvent) => {
                event.preventDefault();
                allBrands.value = "1";
            });
        }
    }

    /**
     *  in der artikelliste gibt es Kategorien die ausgeklappt werden koennen
     */
    private addShowCategoriesListeners(): void {
        const showCategories: NodeListOf<HTMLElement> =
            this.viewRoot.querySelectorAll(".show_categories");
        showCategories.forEach((element) => {
            element.addEventListener("click", (event: MouseEvent) => {
                event.preventDefault();
                const container = element.closest(".wkas") as HTMLElement;
                if (!container) {
                    return;
                }
                const more = container.querySelector(".more") as HTMLElement;
                if (more) {
                    more.classList.remove("hidden");
                }
                element.classList.add("hidden");
            });
        });
    }

    /**
     *  in der artikelliste gibt es Kategorien die eingeklappt werden koennen
     */
    private addHideCategoriesListeners(): void {
        const hideCategories: NodeListOf<HTMLElement> =
            this.viewRoot.querySelectorAll(".hide_categories");
        hideCategories.forEach((element) => {
            element.addEventListener("click", (event: MouseEvent) => {
                event.preventDefault();
                const container = element.closest(".wkas") as HTMLElement;
                if (!container) {
                    return;
                }
                const more = container.querySelector(".more") as HTMLElement;
                if (more) {
                    more.classList.add("hidden");
                }
                const showButton = container.querySelector(
                    ".show_categories",
                ) as HTMLElement;
                if (showButton) {
                    showButton.classList.remove("hidden");
                }
            });
        });
    }

    /**
     * beim klicken auf eine Kategorie wird der Filter gesetzt und alle anderen Filter entfernt
     */
    private clickCategoriesListener(): void {
        const inputs = Array.from(
            this.viewRoot.querySelectorAll<HTMLInputElement>(".wkas input"),
        );

        inputs.forEach((el) => {
            el.addEventListener("click", (e) => {
                e.preventDefault();
                e.stopImmediatePropagation();

                const wkaFilter = el.closest(".wka_filter");
                const currentId = el.id;

                if (el.checked) {
                    Array.from(
                        wkaFilter?.querySelectorAll<HTMLInputElement>(
                            "input",
                        ) || [],
                    ).forEach((checkbox) => {
                        if (checkbox.id !== currentId) {
                            checkbox.checked = false;
                        }
                    });
                }

                const form = el.closest("form");
                if (!form) {
                    return;
                }
                Array.from(
                    form.querySelectorAll<HTMLInputElement>("input"),
                ).forEach((input) => {
                    const cleanFilter = input.dataset.cleanfilter;
                    if (!input.closest(".wkas") && cleanFilter !== "no") {
                        input.value = "";
                        input.checked = false;
                    }
                });
                this.reloadManager.reloadModule(form);
            });
        });
    }

    /**
     *  zum zuruecksetzen ALLER Filter
     */
    private resetFilterListeners(): void {
        const resetButtons = this.viewRoot.querySelectorAll<HTMLAnchorElement>(
            ".moduleCms_articlelist .reset-filter",
        );
        resetButtons.forEach((element) => {
            element.addEventListener("click", (event: MouseEvent) => {
                event.preventDefault();
                event.stopImmediatePropagation();

                let form = element.closest("form") as HTMLFormElement | null;
                if (!form) {
                    // wenn der reset button nicht in einem formular liegt, gehe zu module-root und schaue in dem modul nach einem form
                    const cmsRoot = element.closest(".cms-module-root");
                    form = cmsRoot ? cmsRoot.querySelector("form") : null;
                }
                if (!form) {
                    return;
                }

                // Setze alle Eingabefelder im Formular zurueck
                form.querySelectorAll<HTMLInputElement>("input").forEach(
                    (input) => {
                        const cleanFilter = input.dataset.cleanfilter;
                        if (!cleanFilter || cleanFilter !== "no") {
                            input.value = "";
                            input.checked = false;
                        }
                    },
                );

                const result = this.reloadManager.reloadModule(form);

                this.openFilterDrawerAfterReload(result, element);
            });
        });
    }

    /**
     *  zum zuruecksetzen von einem Filter (z.b. Apple)
     */
    private resetFilterListenersByOneItem(): void {
        const resetButtons = this.viewRoot.querySelectorAll<HTMLAnchorElement>(
            ".moduleCms_articlelist .quick-filter-item",
        );
        resetButtons.forEach((element) => {
            element.addEventListener("click", (event: MouseEvent) => {
                event.preventDefault();
                event.stopImmediatePropagation();

                const form = element.closest("form") as HTMLFormElement | null;
                const filterIdentifier = element.getAttribute("data-id");
                if (!form || !filterIdentifier) {
                    return;
                }

                const inputs = form.querySelectorAll<HTMLInputElement>(
                    `input[data-filter-identifier="${filterIdentifier}"]`,
                );

                inputs.forEach((input) => {
                    if (filterIdentifier.includes("eadavk")) {
                        input.value = "";
                    } else {
                        input.checked = false;
                    }
                });

                const result = this.reloadManager.reloadModule(form);

                this.openFilterDrawerAfterReload(result, element);
            });
        });
    }

    /**
     *  beim sortieren der Liste wird ein submit ausgefuehrt
     */
    private submitListenersByOrderByFilter(): void {
        const form = this.viewRoot.querySelector<HTMLFormElement>(
            "form.form_moduleCms_articlelist",
        );
        if (!form) {
            return;
        }

        form.addEventListener("submit", (event: SubmitEvent) => {
            event.preventDefault();
            event.stopImmediatePropagation();

            this.reloadManager.reloadModule(form);
        });
    }

    /**
     *  die artikelliste hat einen buttom um weitere Filter in einem Drawer zu oeffnen
     */
    private moreFilterListener(): void {
        const moreFilterButtons =
            this.viewRoot.querySelectorAll<HTMLAnchorElement>(
                ".moduleCms_articlelist .more-filters",
            );
        moreFilterButtons.forEach((element) => {
            element.addEventListener("click", (event: MouseEvent) => {
                event.preventDefault();

                const form = element.closest("form");
                if (!form) {
                    return;
                }
                const moduleRoot = form.closest(
                    ".cms-module-root",
                ) as HTMLElement | null;
                if (moduleRoot) {
                    const cmsmoduleid = moduleRoot.dataset.moduleId;
                    if (cmsmoduleid) {
                        this.openDrawer(cmsmoduleid);
                    }
                }
            });
        });
    }

    public openDrawer(cmsmoduleid: string): void {
        const drawer = this.viewRoot.querySelector<SlDrawer>(
            "#articlelist_filter" + cmsmoduleid,
        );
        const header = notNull(
            document.querySelector<HTMLElement>("#header"),
        ) as HTMLElement;
        const html = notNull(
            document.querySelector<HTMLElement>("html"),
        ) as HTMLElement;
        const trustedShop = document.querySelector<HTMLElement>(
            "#trustbadge-container-98e3dadd90eb493088abdc5597a70810",
        );
        const ratingGoogle =
            document.querySelector<HTMLElement>("#I1_1663834711508");

        if (!drawer || !header) {
            return;
        }
        drawer.show();

        // Anpassen des Z-Index und Deaktivieren des Scrollens
        header.style.zIndex = "0";
        html.style.overflow = "hidden";
        html.style.height = "100%";

        if (trustedShop) {
            trustedShop.style.display = "none";
        }
        if (ratingGoogle) {
            ratingGoogle.style.display = "none";
        }

        // Schliessen des Drawers ueber den "closeFilter"-Button  (Filter anwenden)
        const closeButton = drawer.querySelector<HTMLElement>(".closeFilter");
        closeButton?.addEventListener("click", (event: Event) => {
            event.preventDefault();
            event.stopImmediatePropagation();
            this.closeDrawer(drawer);
        });

        // Schliessen des Drawers, wenn ein `sl-request-close`-Event ausgeloest wird (man klickt ausserhalb des Drawers)
        drawer.addEventListener("sl-request-close", (event: Event) => {
            event.preventDefault();
            event.stopImmediatePropagation();
            this.closeDrawer(drawer);
        });
    }

    private closeDrawer(drawer: SlDrawer): void {
        const header = notNull(
            document.querySelector<HTMLElement>("#header"),
        ) as HTMLElement;
        const html = notNull(
            document.querySelector<HTMLElement>("html"),
        ) as HTMLElement;
        const trustedShop = document.querySelector<HTMLElement>(
            "#trustbadge-container-98e3dadd90eb493088abdc5597a70810",
        );
        const ratingGoogle =
            document.querySelector<HTMLElement>("#I1_1663834711508");

        drawer.hide();

        // Wiederherstellung der HTML- und Header-Einstellungen
        html.style.removeProperty("overflow");
        html.style.removeProperty("height");
        header.style.removeProperty("z-index");

        if (trustedShop) {
            trustedShop.style.removeProperty("display");
        }
        if (ratingGoogle) {
            ratingGoogle.style.removeProperty("display");
        }
    }

    /**
     * beim klick auf eine andere Farbe oder Groesse wird der Artikel in der Liste getauscht
     */
    private changeColorSizeClickListener(): void {
        const colorElements = this.viewRoot.querySelectorAll(
            ".cms-module-artikellist .cms-article-list-list .colors_memory li",
        );
        colorElements.forEach((element: Element) => {
            element.addEventListener("click", (event) => {
                event.preventDefault();
                this.changeArticle(element);
            });
        });
    }

    private changeArticle(element: Element): void {
        const imgurl = element.getAttribute("data-imageurl");
        const artid = element.getAttribute("data-artid");
        const container = element.closest("li.articlebox");

        if (!container || !artid || !imgurl) {
            return;
        }

        // Bild-Element erstellen und URL setzen
        const img = new Image();
        img.src = imgurl;

        const apiurl = `/modulecmsapi/api_articlelist_change/${artid}`;

        const settings = {
            method: "POST",
            headers: { "X-Requested-With": "XMLHttpRequest" },
            cache: "default" as RequestCache,
            credentials: "same-origin" as RequestCredentials,
        };

        fetch(apiurl, settings)
            .then((response) => {
                if (response.ok) {
                    return response.text();
                }
                throw new Error("Fehler beim Abrufen der Artikeldaten");
            })
            .then((content) => {
                if (content) {
                    container.innerHTML = content;
                    // Erneut Event-Listener setzen
                    const colorElements =
                        container.querySelectorAll(".colors_memory li");
                    colorElements.forEach((element: Element) => {
                        element.addEventListener("click", (event) => {
                            event.preventDefault();
                            this.changeArticle(element);
                        });
                    });
                }
            });
    }

    /**
     *  Innerhalb der Artikelliste, die in Tarifdetail auf Klick nachgeladen wird, kommen hier die events fuer speicher / farbauswahl
     *  Beispiel Testlink fuer Tarifdetail mit optionalem Artikel: https://www.handytick.pp24/handyvertrag-vergleich/telefonica/o2-telefonica-free-l-boost-10-2018.htm
     */
    private changeTarifdetailColorSizeClickListener(): void {
        const colorElements = this.viewRoot.querySelectorAll(
            ".tarif_detail_section .cms-article-list-list .colors_memory li, .tarif_detail_section  .col2 .colors_memory li",
        );
        colorElements.forEach((element: Element) => {
            element.addEventListener("click", (event) => {
                event.preventDefault();
                event.stopImmediatePropagation();
                this.changeArticleOnTarifdetail(element);
            });
        });
    }

    private changeArticleOnTarifdetail(element: Element): void {
        const artid = element.getAttribute("data-artid");
        const container = element.closest("li.articlebox");
        const containerTrigger = container?.closest("ul");
        const tarifid = container?.getAttribute("data-tarifid");
        const recombiArtid = container?.getAttribute("data-rartid");

        if (!artid || !tarifid || !container || !containerTrigger) {
            return;
        }

        let apiurl = `/tarif/api_article_change/${artid}/${tarifid}`;
        if (recombiArtid) {
            apiurl = `/tarif/api_article_change/${artid}/${tarifid}/${recombiArtid}`;
        }

        const settings = {
            method: "POST",
            headers: { "X-Requested-With": "XMLHttpRequest" },
            cache: "default" as RequestCache,
            credentials: "same-origin" as RequestCredentials,
        };

        fetch(apiurl, settings)
            .then((response) => {
                if (response.ok) {
                    return response.text();
                }
                throw new Error("Fehler beim Laden des Artikels.");
            })
            .then((content) => {
                if (content) {
                    container.outerHTML = content;
                    const colorElements =
                        containerTrigger.querySelectorAll(".colors_memory li");
                    colorElements.forEach((el: Element) => {
                        el.addEventListener("click", (event) => {
                            event.preventDefault();
                            event.stopImmediatePropagation();
                            this.changeArticleOnTarifdetail(el);
                        });
                    });
                }
            });
    }

    /**
     * pagination, naechste seite laden
     */
    private showMoreArticlesListener(): void {
        const showMoreItems = this.viewRoot.querySelectorAll<SlButton>(
            ".moduleCms_articlelist .showMoreItems sl-button",
        );
        showMoreItems.forEach((element: SlButton) => {
            element.addEventListener("click", (event) => {
                event.preventDefault();
                const moduleRoot = element.closest(
                    ".cms-module-root",
                ) as HTMLElement;
                if (!moduleRoot) {
                    return;
                }

                const form = moduleRoot.querySelector(
                    "form",
                ) as HTMLFormElement;
                if (!form) {
                    return;
                }

                const limitInput = form.querySelector(
                    'input[name="limit"]',
                ) as HTMLInputElement;
                if (!limitInput) {
                    return;
                }
                const currentLimit = parseInt(limitInput.value, 10);
                if (!isNaN(currentLimit)) {
                    limitInput.value = (currentLimit + 6).toString();
                    this.reloadManager.reloadModule(form);
                }
            });
        });
    }

    private openFilterDrawerAfterReload(
        result: Promise<HTMLElement> | null,
        target: HTMLElement,
    ): void {
        const elementOnLayer = target.closest("sl-drawer") as SlDrawer | null;
        if (elementOnLayer === null) {
            return;
        }

        if (result === null) {
            return;
        }

        result.then((moduleRoot) => {
            new Articlelist(moduleRoot).openDrawer(
                notNull(moduleRoot.getAttribute("data-module-id")),
            );
        });
    }
}
